export const manifestsCatalog = [
  { manifestId: 'https://files.tetras-libre.fr/dev/sun-400x400.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/test-vertical-video.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/Heterogeneous-media-on-several-canvases.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/Clock/manifestWithAnnotationTemplates_MAE.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/Clock/manifest.json' },
  { manifestId: 'https://iiif.io/api/cookbook/recipe/0074-multiple-language-captions/manifest.json' },
  { manifestId: 'https://iiif.harvardartmuseums.org/manifests/object/299843' },
  { manifestId: 'https://iiif.io/api/cookbook/recipe/0002-mvm-audio/manifest.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/vertical_video_with_annot.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/youtube.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/peertube.json' },
  { manifestId: 'https://files.tetras-libre.fr/dev/milansanremo25.json' },
];
